/*
*
* 2015 Apollo Theme
*
*/
//========== PRODUCT PAGE ==========//
Shopify.optionsMap = {};
Shopify.optionsMapQuickview = {};
function updatePricing() {
    //try pattern one before pattern 2
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = $('#ProductPrice span').text().match(regex);
    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $('#ProductPrice span').text().match(regex);      
    }
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];      
        var unitPrice = unitPriceText.replace(/[.|,]/g,'');
        var quantity = parseInt($('#Quantity').val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        totalPriceText = totalPriceText.match(regex)[0];
        var regInput = new RegExp(unitPriceText, "g");  
        var totalPriceHtml = $('.product .price').html().replace(regInput ,totalPriceText); 
        $('.product .total-price span').html(totalPriceHtml);
    }
}
function updatePricingQuickView() {
    
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);
    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);
    }
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g,'');
        var quantity = parseInt(jQuery('.quick-view-product input[name=quantity]').val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        totalPriceText = totalPriceText.match(regex)[0];
        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = jQuery('.quick-view-product .price').html().replace(regInput ,totalPriceText);
        jQuery('.quick-view-product .total-price span').html(totalPriceHtml);
    }
}
function updateOptionsInSelector(t, from) {
    var sel = (from != "quickview") ? "" : ".quick-view-product ";
    switch (t) {
    case 0:
        var n = "root";
        var r = $(from + ".single-option-selector:eq(0)");
        break;
    case 1:
        var n = $(from + ".single-option-selector:eq(0)").val();
        var r = $(from + ".single-option-selector:eq(1)");
        break;
    case 2:
        var n = $(from + ".single-option-selector:eq(0)").val();
        n += " / " + $(from + ".single-option-selector:eq(1)").val();
        var r = $(from + ".single-option-selector:eq(2)")
    }
    var i = r.val();
    r.empty();
    var s = (from != "quickview") ? Shopify.optionsMap[n] : Shopify.optionsMapQuickview[n];
    if(typeof s != "undefined"){
        for (var o = 0; o < s.length; o++) {
            var u = s[o];
            var a = $("<option></option>").val(u).html(u);
            r.append(a)
        }
    }
    $(from + '.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr("data-value"), s) !== -1) {
            $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
        } else {
            $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }
    });
    if ($.inArray(i, s) !== -1) {
        r.val(i)
    }
    r.trigger("change")
};
function linkOptionSelectors(t) {
    for (var n = 0; n < t.variants.length; n++) {
        var r = t.variants[n];
        if (r.available) {
            Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
            Shopify.optionsMap["root"].push(r.option1);
            Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
            if (t.options.length > 1) {
                var i = r.option1;
                Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
                Shopify.optionsMap[i].push(r.option2);
                Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
            }
            if (t.options.length === 3) {
                var i = r.option1 + " / " + r.option2;
                Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
                Shopify.optionsMap[i].push(r.option3);
                Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
            }
        }
    }
    updateOptionsInSelector(0, "detail");
    if (t.options.length > 1)
        updateOptionsInSelector(1);
    if (t.options.length === 3)
        updateOptionsInSelector(2, "detail");
    $(".single-option-selector:eq(0)").change(function() {
        updateOptionsInSelector(1);
        if (t.options.length === 3)
            updateOptionsInSelector(2, "detail");
        return true
    });
    $(".single-option-selector:eq(1)").change(function() {
        if (t.options.length === 3)
            updateOptionsInSelector(2, "detail");
        return true
    });
}
function linkOptionSelectorsQuickview(t) {
    for (var n = 0; n < t.variants.length; n++) {
        var r = t.variants[n];
        if (r.available) {
            Shopify.optionsMapQuickview["root"] = Shopify.optionsMapQuickview["root"] || [];
            Shopify.optionsMapQuickview["root"].push(r.option1);
            Shopify.optionsMapQuickview["root"] = Shopify.uniq(Shopify.optionsMapQuickview["root"]);
            if (t.options.length > 1) {
                var i = r.option1;
                Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                Shopify.optionsMapQuickview[i].push(r.option2);
                Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
            }
            if (t.options.length === 3) {
                var i = r.option1 + " / " + r.option2;
                Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                Shopify.optionsMapQuickview[i].push(r.option3);
                Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
            }
        }
    }
    updateOptionsInSelector(0, "quickview");
    if (t.options.length > 1)
        updateOptionsInSelector(1);
    if (t.options.length === 3)
        updateOptionsInSelector(2, "quickview");
    $(".single-option-selector:eq(0)").change(function() {
        updateOptionsInSelector(1);
        if (t.options.length === 3)
            updateOptionsInSelector(2, "quickview");
        return true
    });
    $(".single-option-selector:eq(1)").change(function() {
        if (t.options.length === 3)
            updateOptionsInSelector(2, "quickview");
        return true
    });
}
var responsiveflag = false;
var loadIcon = "//outdoorshop.nz/cdn/shop/t/2/assets/loading.gif?v=74321011833449561481515802228";

$(document).ready(function(){
	
    productImage();
    
    	iniWishlist();
	
  	initPriceAction();  	
  	responsiveResize();
	$(window).resize(responsiveResize);
  	responsiveProductZoom();
	offCanvas();
	floatHeader();
	floatTopbar();
	backtotop();
	
	changeFloatHeader();
	changeLayoutMode();
	changeHeaderStyle();
  	changeSkinsStyle();
	addFilterEffect();
  	setLeftColumn();
  	setRightColumn();
	$(".hover-bimg").mouseenter(function() {
  		$(this).closest('.product-image-container').find('.product_img_link').first().find('img').first().attr('src', $(this).data('bimg'));
	});
});
function initPriceAction(){	
    $(document).on('click', '.btn-price-action', function(e){
      	e.preventDefault();
      	$.cookie('priceMatch', $('#ProductPrice').text(), {expires:1, path:'/'});    	
      	$.cookie('productNameMatch', $('.title_product_detail').text(), {expires:1, path:'/'});
      	window.location.href = '/pages/price-match';
      	return false;
    });
}


//========== END PRODUCT PAGE ==========//
//========== QUICK VIEW ==========//

function displayImage(domAAroundImgThumb)
{
	if (domAAroundImgThumb.attr('href'))
	{
		var new_src = domAAroundImgThumb.attr('href').replace('1024x1024', 'grande');
		var new_title = domAAroundImgThumb.attr('title');
		var new_href = domAAroundImgThumb.attr('href');
		if ($('#bigpic').attr('src') != new_src)
		{
			$('#bigpic').attr({
				'src' : new_src,
				'alt' : new_title,
				'title' : new_title
			});
		}
		$('#views_block li a').removeClass('shown');
		$(domAAroundImgThumb).addClass('shown');
	}
}
function productZoom(status){
  	if(status == 'enable') {
  		$("#proimage").elevateZoom({
          	
            zoomType: "window",
            cursor: 'pointer',
          	
          	responsive: true,gallery:'thumbs_list', galleryActiveClass: 'active', imageCrossfade: true,scrollZoom : true,onImageSwapComplete: function() {$(".zoomWrapper div").hide()},loadingIcon: loadIcon
        });
        $("#proimage").bind("click", function(e) {var ez = $('#proimage').data('elevateZoom');$.fancybox(ez.getGalleryList()); return false; });
    }
  	else{$(document).on('click', '#thumbs_list .thumb_item a', function(){if ($(this).attr('href')){var new_src = $(this).data('image');var new_title = $(this).attr('title');var new_href = $(this).attr('href');if ($('#proimage').attr('src') != new_src){$('#proimage').attr({'src' : new_src,'alt' : new_title,'title' : new_title});}}});}
}
function productImage() {
	$('#thumblist').owlCarousel({
        navigation: true,
        items: 3,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [768, 3],
        itemsTabletSmall: [540, 3],
        itemsMobile: [360, 3]
    });
    $('.thumbs_list_frame').height(parseInt($('.thumbs_list_frame >li').outerHeight(true) * $('.thumbs_list_frame >li').height) + 'px');
    $('.thumbs_list').serialScroll({
        items:'li:visible',
        prev:'.view_scroll_left',
        next:'.view_scroll_right',
        axis:'y',
        start:0,
        stop:true,
        duration:700,
        step: 2,
        lazy: true,
        lock: false,
        force:false,
        cycle:false
    });
	if (!!$.prototype.fancybox){
		$('li:visible .fancybox, .fancybox.shown').fancybox({
			'hideOnContentClick': true,
			'openEffect'	: 'elastic',
			'closeEffect'	: 'elastic'
		});
	}
}

	function iniWishlist(){
		$(".wishlist button.btn-wishlist").click(function(e){
			e.preventDefault();
			var d = $(this).parent();
			$.ajax({
				type:"POST",
				url:"/contact",
				data:d.serialize(),
				beforeSend:function(){

				},
				success:function(n){
					d.html('<a class="btn btn-outline-inverse btn-wishlist" href="/pages/wish-list">Go to Wishlist</a>');
					if (!!$.prototype.fancybox)
						$.fancybox.open([{
							type: 'inline',
							autoScale: true,
							minHeight: 30,
							content: '<p class="fancybox-error">' + 'Added to your wishlist.' + '</p>'
						}], {
							padding: 0
						});
					else
						alert('Added to your wishlist.');
				},
				error:function(){
					
				}
			})
		});
	}

// Used to compensante Chrome/Safari bug (they don't care about scroll bar for width)
function scrollCompensate() 
{
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
}
function responsiveResize()
{
	compensante = scrollCompensate();
	if (($(window).width()+scrollCompensate()) <= 767 && responsiveflag == false)
	{
		accordion('enable');
	    accordionFooter('enable');
		responsiveflag = true;	
	}
	else if (($(window).width()+scrollCompensate()) >= 768)
	{
		accordion('disable');
		accordionFooter('disable');
	    responsiveflag = false;
	}
  	if ($(window).width() <= 767)
	{
		accordionVerticalMenu('enable');
	}
	else if ($(window).width() >= 767)
	{
		accordionVerticalMenu('disable');
	}
}
function responsiveProductZoom()
{
	if (($(window).width()) >= 992){
    	productZoom('enable');
    }
  	else if (($(window).width()) <= 991){
  		productZoom('disable');
    }
}
function offCanvas(){
	$('[data-toggle="offcanvas"]').click(function () {
	    var menuCanvas = $(this).data('target');
	    $(this).toggleClass('open');
	    $(menuCanvas).toggleClass('active');
	    $('body').toggleClass('off-canvas-active');
	    var heightCanvas = $(window).height();
	    $(menuCanvas).css({'min-height' : heightCanvas});
  	});
  	$('.off-canvas-nav').click(function () {
  		$('[data-toggle="offcanvas"]').click();
  	});
}
function accordion(status)
{
 	leftColumnBlocks = $('#left_column');
 	if(status == 'enable')
 	{
      	if(!$('#left_column').hasClass('accordion')){
        	$('#right_column .block .title_block, #left_column .block .title_block').on('click', function(){
   				$(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
  			});
      	}
  		$('#right_column, #left_column').addClass('accordion').find('.block .block_content').slideUp('fast');
 	}
 	else
 	{
  		$('#right_column .block .title_block, #left_column .block .title_block').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
  		$('#left_column, #right_column').removeClass('accordion');
 	}
}
function accordionFooter(status){
 	if(status == 'enable') {
       if(!$('#footercenter').hasClass('accordion')){
          $('#footercenter .footer-block h4').on('click', function(){
              $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
          })
        }
  		$('#footercenter').addClass('accordion').find('.block_content').slideUp('fast');
 	}
 	else {
  		$('.footer-block h4').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
  		$('#footercenter').removeClass('accordion');
 	}
}
function accordionVerticalMenu(status){
    if(status == 'enable') {
      	if(!$('#apollo-verticalmenu').hasClass('accordion')) {
        	$('#apollo-verticalmenu .block-title').on('click', function(){
          		$(this).toggleClass('active').parent().find('.block-content').stop().slideToggle('medium');
        	})
        	$('#apollo-verticalmenu').find('.block-content').slideUp('fast');
      	}
      	$('#apollo-verticalmenu').addClass('accordion').find('.block-content').slideUp('fast');
    }
    else {
      	$('#apollo-verticalmenu .block-title').removeClass('active').off().parent().find('.block-content').removeAttr('style').slideDown('fast');
      	$('#apollo-verticalmenu').removeClass('accordion');
    }
}
//Float Menu
function processFloatHeader(headerAdd, scroolAction){
	if(headerAdd){
		$("#header").addClass( "navbar-fixed-top" );
	    $("#page").css( "padding-top", $("#header").height());
	    var hideheight =  $("#header").height()+120;
	    var pos = $(window).scrollTop();
	    if( scroolAction && pos >= hideheight ){
	        $("#topbar").addClass('hide-bar');
	        $(".hide-bar").css( "margin-top", - $("#topbar").height() );
	    }else {
	        $("#topbar").css( "margin-top", 0 );
	    }
	}else{
		$("#header").removeClass( "navbar-fixed-top" );
	    $("#page").css( "padding-top", '');
        $("#header-main").removeClass('hidden');
        $("#apollo-menu").removeClass('hidden');
        $("#topbar").css( "margin-top", 0 );

	}
	
}
function processFloatTopbar(topbarAdd, scroolAction){
	if(topbarAdd){
		$("#header").addClass( "navbar-fixed-top" );
	    $("#page").css( "padding-top", $("#header").height());
	    var hideheightBar =  $("#header").height()+120;
	    var pos = $(window).scrollTop();
	    if( scroolAction && pos >= hideheightBar ){
	        $("#header-main").addClass('hidden');
			$("#apollo-menu").addClass('hidden');
	    }else {
	        $("#header-main").removeClass('hidden');
	        $("#apollo-menu").removeClass('hidden');
	    }
	}else{
		$("#header").removeClass("navbar-fixed-top");
	    $("#page").css( "padding-top", '');
	    $("#header-main").removeClass('hidden');
	    $("#apollo-menu").removeClass('hidden');
        $("#topbar").css( "margin-top", 0 );
	}

}
function floatHeader(){
	$(window).resize(function(){
		if (!$("body").hasClass("keep-header") || $(window).width() <= 990){
			return;
		}
		if ($(window).width() <= 990)
		{
			processFloatHeader(0,0);
		}
		else if ($(window).width() > 990)
		{
			if ($("body").hasClass("keep-header"))
				processFloatHeader(1,1);
		}
	});
    $(window).scroll(function() {
    	if (!$("body").hasClass("keep-header")) return;
    	if($(window).width() > 990){
	         processFloatHeader(1,1);

    	}
    });
}
function floatTopbar(){
	$(window).resize(function(){
		if (!$("body").hasClass("keep-topbar") || $(window).width() <= 990){
			return;
		}
		if ($(window).width() <= 990)
		{
			processFloatTopbar(0,0);
		}
		else if ($(window).width() > 990)
		{
			if ($("body").hasClass("keep-topbar"))
				processFloatTopbar(1,1);
		}
	});
    $(window).scroll(function() {
    	if (!$("body").hasClass("keep-topbar")) return;
    	if($(window).width() > 990){
	         processFloatTopbar(1,1);

    	}
    });
}
// Back to top
function backtotop(){
	// Hide #back-top first
	$("#back-top").hide();
	// Fade in #back-top
	$(function () {
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				$('#back-top').fadeIn();
			} else {
				$('#back-top').fadeOut();
			}
		});
		// Scroll body to 0px on click
		$('#back-top a').click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 800);
			return false;
		});
	});
}
function panelTool(){
	$('#paneltool .panelbutton').click(function(){
		$('#paneltool .paneltool').toggleClass('active');
	});
}
function changeFloatHeader(){
	$('#floatHeader').click(function(){
		if ($('body').hasClass('keep-header')) {
			$('body').removeClass('keep-header');
			processFloatHeader(0,0);
		}
		else{
			processFloatTopbar(0,0);
			$('body').addClass('keep-header');
			$('body').removeClass('keep-topbar');
			$("#floatTopbar").prop("checked", false);
		};
	});
	$('#floatTopbar').click(function(){
		if ($('body').hasClass('keep-topbar')) {
			$('body').removeClass('keep-topbar');
			processFloatTopbar(0,0);
		}
		else{
			processFloatHeader(0,0);
			$('body').addClass('keep-topbar');
			$('body').removeClass('keep-header');
			$("#floatHeader").prop("checked", false);
		};
	});
}
function changeLayoutMode(){
    $('.dynamic-update-layout').click(function(){
        var currentLayoutMode = $('.dynamic-update-layout.selected').data('layout-mode');
        if(!$(this).hasClass('selected'))
        {
            $('.dynamic-update-layout').removeClass('selected');
            $(this).addClass('selected');
            selectedLayout = $(this).data('layout-mode');
            $('body').removeClass(currentLayoutMode);
            $('body').addClass(selectedLayout);
        }
    });
}
function changeHeaderStyle(){
    $('.dynamic-update-header').click(function(){
        var currentHeaderMode = $('.dynamic-update-header.selected').data('header-style');
        if(!$(this).hasClass('selected'))
        {
            $('.dynamic-update-header').removeClass('selected');
            $(this).addClass('selected');
            selectedHeaderStyle = $(this).data('header-style');
            $('body').removeClass(currentHeaderMode);
            $('body').addClass(selectedHeaderStyle);
        }
    });
}
function changeSkinsStyle(){
    $('.dynamic-update-skins').click(function(){
        var currentSkins = $('.dynamic-update-skins.selected').data('skins');
        if(!$(this).hasClass('selected'))
        {
            $('.dynamic-update-skins').removeClass('selected');
            $(this).addClass('selected');
            selectedSkins = $(this).data('skins');
            $('body').removeClass(currentSkins);
            $('body').addClass(selectedSkins);
        }
    });
}
function addFilterEffect(){
	if($("#catalog_block").length && $("#catalog_block").hasClass('ajax-filter')){
		//if this page is collection page
		if($('.catalog_filters').length){
			$('.advanced-filter').each(function(){
				dataGroup = $(this).data('group');
				if(dataGroup != "Vendor"){
					activeFilter='';
					if($(this).hasClass('active-filter')) 
						activeFilter=' checked="checked"';
					
					$('a', $(this)).each(function(){
						var dataHandle = $(this).parent().data("handle");
						$('<input class="chkval" type="checkbox" name='+dataGroup+activeFilter+' value="'+dataHandle+'"/>').insertBefore($(this));
						$(this).click(function(event){
							chkVal = $(this).parent().find('.chkval');
							chkVal.prop("checked", !chkVal.prop("checked"));
							$(this).parent().toggleClass("active-filter");
							FilterLoadResult();
							return false;
						});
					})
				}
			});
		}

		//add ajax for sort
		$("#SortBy").change(function(event){
			event.preventDefault();

			var url      = window.location.href;
			url = replaceUrlParam(url, 'sort_by', $(this).val());

			processCollectionAjax(url);
			return false;
		});
		//add ajax for view
		$(".change-view").click(function(event){
			event.preventDefault();
			if($(this).hasClass('change-view--active')) return false;

			$(".change-view").removeClass('change-view--active');
			$(this).addClass('change-view--active');

			var url      = window.location.href;
			url = replaceUrlParam(url, 'view', $(this).data('view'));
			//add class for product list

			processCollectionAjax(url);

			$('.product_list').removeClass('list').removeClass('grid').addClass($(this).data('view'));
			return false;
		});

		pagingCollection();
	}
}

function pagingCollection(){
	activeNumber = parseInt($('.pagination li.active span').html());

	$('#pagination .pagination a').click(function(){
		var pageNumber = 0;
		//previous

		if($(this).parent().hasClass('pagination_previous')){
			pageNumber = activeNumber-1;
		}
		//next
		else if($(this).parent().hasClass('pagination_next')){
			pageNumber = activeNumber+1;
		}
		//normal paging
		else{
			pageNumber = parseInt($(this).html());
		}
		if(pageNumber >0){
			var url      = window.location.href;
			url = replaceUrlParam(url, 'page', pageNumber);

			processCollectionAjax(url);
		}
		return false;
	});
}
function FilterLoadResult(){
	var url      = window.location.href;
	var constraint = '';

	$('.chkval').each(function(){
		if($(this).is(":checked"))
			constraint += !constraint?$(this).val().toLowerCase():"+"+$(this).val().toLowerCase();
	});
	url = replaceUrlParam(url, 'constraint', constraint);
	processCollectionAjax(url);
}
function processCollectionAjax(url){
	$.ajax({
        type: 'GET',
        url: url,
        data: {},
        beforeSend:function(){
        	$('.product_list').addClass('loading');
		},
        complete: function (data) {
            $('.product_list').html($(".product_list", data.responseText).html());
            $('#pagination').remove();
            $('.content_sortPagiBar').html($(".content_sortPagiBar", data.responseText).html());
            $('.product_list').removeClass('loading');
            
            history.pushState({
                page: url
            }, url, url);
            pagingCollection();
        }
    });
}
function setLeftColumn() {
	if($("#left_column").length > 0) {
        if($(".over-cover").length == 0) {
            $('body').append($('<div class="over-cover"></div><div class="drag-target-left"><div class="drag-panel-left"></div></div>'));
            $('body').append($('<a href="javascript:;" data-activates="slide-out" class="button-collapse-left"><i class="mdi-navigation-menu"></i></a>'));
        }
      	$(".button-collapse-left").click(function() {
            $(".drag-target-left, .button-collapse-left").addClass("hide");
          	$("body").addClass("move-left-to-right");
            $('#left_column').css("left", "-400px");
            setTimeout(function() {
                $("#left_column").parent().addClass("side-nav-container-left");
                $("#left_column").addClass("side-nav-left");
            }, 200);
        });
        $(".over-cover").click(function() {
          	$(".drag-target-left, .button-collapse-left").removeClass("hide");
            $("#left_column").parent().removeClass("side-nav-container-left");
            $("#left_column").removeClass("side-nav-left");
            $("body").removeClass("move-left-to-right");
            $(".box-left-menu").addClass("menu-close");
            $('#left_column').css("left", "");
        });
        $(".drag-target-left").click(function() {
            console.log("drag-target click");
            $(".button-collapse-left").trigger("click");
        });
    }
}
function setRightColumn() {
  	if($("#right_column").length > 0) {
        if($(".over-cover").length == 0) {
            $('body').append($('<div class="over-cover"></div><div class="drag-target-right"><div class="drag-panel-right"></div></div>'));
            $('body').append($('<a href="javascript:;" data-activates="slide-out" class="button-collapse-right"><i class="mdi-navigation-menu"></i></a>'));
        }

        $(".button-collapse-right").click(function() {
            $(".drag-target-right, .button-collapse-right").addClass("hide");
          	$("body").addClass("move-right-to-left");
            $('#right_column').css("right", "-400px");
            setTimeout(function() {
                $("#right_column").parent().addClass("side-nav-container-right");
                $("#right_column").addClass("side-nav-right");
            }, 200);
        });
        $(".over-cover").click(function() {
          	$(".drag-target-right, .button-collapse-right").removeClass("hide");
            $("#right_column").parent().removeClass("side-nav-container-right");
            $("#right_column").removeClass("side-nav-right");
            $("body").removeClass("move-right-to-left");
            $(".box-right-menu").addClass("menu-close");
            $('#right_column').css("right", "");
        });
        $(".drag-target-right").click(function() {
            console.log("drag-target click");
            $(".button-collapse-right").trigger("click");
        });
    }
}
function replaceUrlParam(url,paramName,paramValue){var pattern=new RegExp('('+paramName+'=).*?(&|$)'),newUrl=url.replace(pattern,'$1'+paramValue+'$2');if(newUrl==url){newUrl=newUrl+(newUrl.indexOf('?')>0?'&':'?')+paramName+'='+paramValue}
return newUrl}
window.timber=window.timber||{};timber.cacheSelectors=function(){timber.cache={$html:$('html'),$body:$('body'),$navigation:$('#AccessibleNav'),$changeView:$('.change-view'),$productImage:$('#ProductPhotoImg'),$thumbImages:$('#ProductThumbs').find('a.product-single__thumbnail'),$recoverPasswordLink:$('#RecoverPassword'),$hideRecoverPasswordLink:$('#HideRecoverPasswordLink'),$recoverPasswordForm:$('#RecoverPasswordForm'),$customerLoginForm:$('#CustomerLoginForm'),$passwordResetSuccess:$('#ResetSuccess')}};timber.init=function(){timber.cacheSelectors();timber.accessibleNav();timber.productImageSwitch();timber.responsiveVideos();timber.collectionViews();timber.loginForms()};timber.accessibleNav=function(){var $nav=timber.cache.$navigation,$allLinks=$nav.find('a'),$topLevel=$nav.children('li').find('a'),$parents=$nav.find('.site-nav--has-dropdown'),$subMenuLinks=$nav.find('.site-nav__dropdown').find('a'),activeClass='nav-hover',focusClass='nav-focus';$parents.on('mouseenter touchstart',function(evt){var $el=$(this);if(!$el.hasClass(activeClass)){evt.preventDefault()}
showDropdown($el)});$parents.on('mouseleave',function(){hideDropdown($(this))});$subMenuLinks.on('touchstart',function(evt){evt.stopImmediatePropagation()});$allLinks.focus(function(){handleFocus($(this))});$allLinks.blur(function(){removeFocus($topLevel)});function handleFocus($el){var $subMenu=$el.next('ul'),hasSubMenu=$subMenu.hasClass('sub-nav')?!0:!1,isSubItem=$('.site-nav__dropdown').has($el).length,$newFocus=null;if(!isSubItem){removeFocus($topLevel);addFocus($el)}else{$newFocus=$el.closest('.site-nav--has-dropdown').find('a');addFocus($newFocus)}}
function showDropdown($el){$el.addClass(activeClass);setTimeout(function(){timber.cache.$body.on('touchstart',function(){hideDropdown($el)})},250)}
function hideDropdown($el){$el.removeClass(activeClass);timber.cache.$body.off('touchstart')}
function addFocus($el){$el.addClass(focusClass)}
function removeFocus($el){$el.removeClass(focusClass)}};timber.getHash=function(){return window.location.hash};timber.updateHash=function(hash){window.location.hash='#'+hash;$('#'+hash).attr('tabindex',-1).focus()};timber.productPage=function(options){var moneyFormat=options.money_format,variant=options.variant,selector=options.selector;var $productImage=$('#ProductPhotoImg'),$addToCart=$('#AddToCart'),$productPrice=$('#ProductPrice'),$comparePrice=$('#ComparePrice'),$quantityElements=$('.quantity-selector, label + .js-qty'),$addToCartText=$('#AddToCartText');if(variant){if(variant.featured_image){var newImg=variant.featured_image,el=$productImage[0];Shopify.Image.switchImage(newImg,el,timber.switchImage)}
if(variant.available){$addToCart.removeClass('disabled').prop('disabled',!1);$addToCartText.html("Add to Cart");$quantityElements.show()}else{$addToCart.addClass('disabled').prop('disabled',!0);$addToCartText.html("Sold Out");$quantityElements.hide()}
$productPrice.html(Shopify.formatMoney(variant.price,moneyFormat));if(variant.compare_at_price>variant.price){$comparePrice.html("Compare at"+': '+Shopify.formatMoney(variant.compare_at_price,moneyFormat)).show()}else{$comparePrice.hide()}}else{$addToCart.addClass('disabled').prop('disabled',!0);$addToCartText.html("Unavailable");$quantityElements.hide()}};timber.productImageSwitch=function(){if(timber.cache.$thumbImages.length){timber.cache.$thumbImages.on('click',function(evt){evt.preventDefault();var newImage=$(this).attr('href');timber.switchImage(newImage,null,timber.cache.$productImage)})}};timber.switchImage=function(src,imgObject,el){var $el=$(el);$el.attr('src',src)};timber.responsiveVideos=function(){$('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');$('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>')};timber.collectionViews=function(){if(!$("#catalog_block").length||!$("#catalog_block").hasClass('ajax-filter')){if(timber.cache.$changeView.length){timber.cache.$changeView.on('click',function(){var view=$(this).data('view'),url=document.URL,hasParams=url.indexOf('?')>-1;if(hasParams){window.location=replaceUrlParam(url,'view',view)}else{window.location=url+'?view='+view}})}}};timber.loginForms=function(){function showRecoverPasswordForm(){timber.cache.$recoverPasswordForm.show();timber.cache.$customerLoginForm.hide()}
function hideRecoverPasswordForm(){timber.cache.$recoverPasswordForm.hide();timber.cache.$customerLoginForm.show()}
timber.cache.$recoverPasswordLink.on('click',function(evt){evt.preventDefault();showRecoverPasswordForm()});timber.cache.$hideRecoverPasswordLink.on('click',function(evt){evt.preventDefault();hideRecoverPasswordForm()});if(timber.getHash()=='#recover'){showRecoverPasswordForm()}};timber.resetPasswordSuccess=function(){timber.cache.$passwordResetSuccess.show()};$(timber.init)

if((typeof Shopify)==='undefined'){Shopify={}}
function urlParams(name){name=name.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");var regex=new RegExp("[\\?&]"+name+"=([^&#]*)"),results=regex.exec(location.search);return results==null?"":decodeURIComponent(results[1].replace(/\+/g," "))}
function attributeToString(attribute){if((typeof attribute)!=='string'){attribute+='';if(attribute==='undefined'){attribute=''}}
return jQuery.trim(attribute)};if(!Shopify.formatMoney){Shopify.formatMoney=function(cents,format){var value='',placeholderRegex=/\{\{\s*(\w+)\s*\}\}/,formatString=(format||this.money_format);if(typeof cents=='string'){cents=cents.replace('.','')}
function defaultOption(opt,def){return(typeof opt=='undefined'?def:opt)}
function formatWithDelimiters(number,precision,thousands,decimal){precision=defaultOption(precision,2);thousands=defaultOption(thousands,',');decimal=defaultOption(decimal,'.');if(isNaN(number)||number==null){return 0}
number=(number/100.0).toFixed(precision);var parts=number.split('.'),dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands),cents=parts[1]?(decimal+parts[1]):'';return dollars+cents}
switch(formatString.match(placeholderRegex)[1]){case 'amount':value=formatWithDelimiters(cents,2);break;case 'amount_no_decimals':value=formatWithDelimiters(cents,0);break;case 'amount_with_comma_separator':value=formatWithDelimiters(cents,2,'.',',');break;case 'amount_no_decimals_with_comma_separator':value=formatWithDelimiters(cents,0,'.',',');break}
return formatString.replace(placeholderRegex,value)}}
Shopify.onProduct=function(product){};Shopify.onCartUpdate=function(cart){};Shopify.updateCartNote=function(note,callback){var params={type:'POST',url:'/cart/update.js',data:'note='+attributeToString(note),dataType:'json',success:function(cart){if((typeof callback)==='function'){callback(cart)}
else{Shopify.onCartUpdate(cart)}},error:function(XMLHttpRequest,textStatus){Shopify.onError(XMLHttpRequest,textStatus)}};jQuery.ajax(params)};Shopify.onError=function(XMLHttpRequest,textStatus){var data=eval('('+XMLHttpRequest.responseText+')');if(!!data.message){alert(data.message+'('+data.status+'): '+data.description)}else{alert('Error : '+Shopify.fullMessagesFromErrors(data).join('; ')+'.')}};Shopify.addItem=function(variant_id,quantity,callback){var quantity=quantity||1,params={type:'POST',url:'/cart/add.js',data:'quantity='+quantity+'&id='+variant_id,dataType:'json',success:function(line_item){if((typeof callback)==='function'){callback(line_item)}
else{Shopify.onItemAdded(line_item)}},error:function(XMLHttpRequest,textStatus){Shopify.onError(XMLHttpRequest,textStatus)}};jQuery.ajax(params)};Shopify.addItemFromForm=function(form,callback,errorCallback){var params={type:'POST',url:'/cart/add.js',data:jQuery(form).serialize(),dataType:'json',success:function(line_item){if((typeof callback)==='function'){callback(line_item,form)}
else{Shopify.onItemAdded(line_item,form)}},error:function(XMLHttpRequest,textStatus){if((typeof errorCallback)==='function'){errorCallback(XMLHttpRequest,textStatus)}
else{Shopify.onError(XMLHttpRequest,textStatus)}}};jQuery.ajax(params)};Shopify.getCart=function(callback){jQuery.getJSON('/cart.js',function(cart,textStatus){if((typeof callback)==='function'){callback(cart)}
else{Shopify.onCartUpdate(cart)}})};Shopify.getProduct=function(handle,callback){jQuery.getJSON('/products/'+handle+'.js',function(product,textStatus){if((typeof callback)==='function'){callback(product)}
else{Shopify.onProduct(product)}})};Shopify.changeItem=function(variant_id,quantity,callback){var params={type:'POST',url:'/cart/change.js',data:'quantity='+quantity+'&id='+variant_id,dataType:'json',success:function(cart){if((typeof callback)==='function'){callback(cart)}
else{Shopify.onCartUpdate(cart)}},error:function(XMLHttpRequest,textStatus){Shopify.onError(XMLHttpRequest,textStatus)}};jQuery.ajax(params)};var ajaxifyShopify=(function(module,$){'use strict';var init;var settings,cartInit,$drawerHeight,$cssTransforms,$cssTransforms3d,$nojQueryLoad,$w,$body,$html;var $formContainer,$btnClass,$wrapperClass,$addToCart,$flipClose,$flipCart,$flipContainer,$cartCountSelector,$cartCostSelector,$toggleCartButton,$modal,$cartContainer,$drawerCaret,$modalContainer,$modalOverlay,$closeCart,$drawerContainer,$prependDrawerTo,$callbackData={};var updateCountPrice,flipSetup,revertFlipButton,modalSetup,showModal,sizeModal,hideModal,drawerSetup,showDrawer,hideDrawer,sizeDrawer,loadCartImages,formOverride,itemAddedCallback,itemErrorCallback,cartUpdateCallback,setToggleButtons,flipCartUpdateCallback,buildCart,cartTemplate,adjustCart,adjustCartCallback,createQtySelectors,qtySelectors,validateQty,scrollTop,toggleCallback;init=function(options){settings={method:'drawer',formSelector:'form[action^="/cart/add"]',addToCartSelector:'input[type="submit"]',cartCountSelector:null,cartCostSelector:null,toggleCartButton:null,btnClass:null,wrapperClass:null,useCartTemplate:!0,moneyFormat:'$',disableAjaxCart:!1,enableQtySelectors:!0,prependDrawerTo:'body',onToggleCallback:null};$.extend(settings,options);if(urlParams('method')){settings.method=urlParams('method')}
settings.method=settings.method.toLowerCase();$formContainer=$(settings.formSelector);$btnClass=settings.btnClass;$wrapperClass=settings.wrapperClass;$addToCart=$formContainer.find(settings.addToCartSelector);$flipContainer=null;$flipClose=null;$cartCountSelector=$(settings.cartCountSelector);$cartCostSelector=$(settings.cartCostSelector);$toggleCartButton=$(settings.toggleCartButton);$modal=null;$prependDrawerTo=$(settings.prependDrawerTo);$cssTransforms=Modernizr.csstransforms;$cssTransforms3d=Modernizr.csstransforms3d;$w=$(window);$body=$('body');$html=$('html');$nojQueryLoad=$html.hasClass('lt-ie9');if($nojQueryLoad){settings.useCartTemplate=!1}
if(settings.enableQtySelectors){qtySelectors()}
if(!settings.disableAjaxCart){switch(settings.method){case 'flip':flipSetup();break;case 'modal':modalSetup();break;case 'drawer':drawerSetup();break}
$(document).keyup(function(evt){if(evt.keyCode==27){switch(settings.method){case 'flip':case 'drawer':hideDrawer();break;case 'modal':hideModal();break}}});if($addToCart.length){formOverride()}}
adjustCart()};updateCountPrice=function(cart){if($cartCountSelector){$cartCountSelector.html(cart.item_count).removeClass('hidden-count');if(cart.item_count===0){$cartCountSelector.addClass('hidden-count')}}
if($cartCostSelector){$cartCostSelector.html(Shopify.formatMoney(cart.total_price,settings.moneyFormat))}};flipSetup=function(){drawerSetup();if(!$addToCart.length){return}
$addToCart.addClass('flip__front').wrap('<div class="flip"></div>');var checkoutBtn=$('<a href="/cart" class="flip__back" style="background-color: #C00; color: #fff;" class="flip__checkout">"Check Out" </a>').addClass($btnClass),flipLoader=$('<span class="ajaxcart__flip-loader"></span>'),flipExtra=$('<div class="flip__extra"><a href="#" class="flip__cart">"View Cart" (<span></span>)</a></div>');checkoutBtn.insertAfter($addToCart);flipLoader.insertAfter(checkoutBtn);$flipContainer=$('.flip');if(!$cssTransforms3d){$flipContainer.addClass('no-transforms')}
flipExtra.insertAfter($flipContainer);$flipCart=$('.flip__cart');$flipCart.on('click',function(e){e.preventDefault();showDrawer(!0)});$('input[type="checkbox"], input[type="radio"], select',$formContainer).on('click',function(){revertFlipButton()})};revertFlipButton=function(){$flipContainer.removeClass('is-flipped')};modalSetup=function(){var source=$("#ModalTemplate").html(),template=Handlebars.compile(source);$body.append(template).append('<div class="ajaxcart__overlay"></div>');$modalContainer=$('#AjaxifyModal');$modalOverlay=$('.ajaxcart__overlay');$cartContainer=$('#AjaxifyCart');$modalOverlay.on('click',hideModal);$modalContainer.prepend('<button type="button" class="ajaxcart__close" title="'+"Close Cart"+'">'+"Close Cart"+'</button>');$closeCart=$('.ajaxcart__close');$closeCart.on('click',hideModal);if(!$cssTransforms){$modalContainer.addClass('no-transforms')}
$(window).on({orientationchange:function(e){if($modalContainer.hasClass('is-visible')){sizeModal('resize')}},resize:function(e){if(!$nojQueryLoad&&$modalContainer.hasClass('is-visible')){sizeModal('resize')}}});setToggleButtons()};showModal=function(toggle){$body.addClass('ajaxcart--is-visible');if(!cartInit&&toggle){Shopify.getCart(cartUpdateCallback)}else{sizeModal()}};sizeModal=function(isResizing){if(!isResizing){$modalContainer.css('opacity',0)}
$modalContainer.css({'margin-left':-($modalContainer.outerWidth()/2),'opacity':1});$closeCart.css({'top':10+($cartContainer.find('h1').height()/2)})
$modalContainer.addClass('is-visible');scrollTop();toggleCallback({'is_visible':!0})};hideModal=function(e){$body.removeClass('ajaxcart--is-visible');if(e){e.preventDefault()}
if($modalContainer){$modalContainer.removeClass('is-visible');$body.removeClass('ajaxify-lock')}
toggleCallback({'is_visible':!1})};drawerSetup=function(){var source=$("#DrawerTemplate").html(),template=Handlebars.compile(source),data={wrapperClass:$wrapperClass};$prependDrawerTo.prepend(template(data));$drawerContainer=$('#AjaxifyDrawer');$cartContainer=$('#AjaxifyCart');$drawerCaret=$('.ajaxcart__caret > span');setToggleButtons();var timeout;$(window).resize(function(){clearTimeout(timeout);timeout=setTimeout(function(){if($drawerContainer.hasClass('is-visible')){positionCaret();sizeDrawer()}},500)});positionCaret();function positionCaret(){if($toggleCartButton.offset()){var togglePos=$toggleCartButton.offset(),toggleWidth=$toggleCartButton.outerWidth(),toggleMiddle=togglePos.left+toggleWidth/2;$drawerCaret.css('left',toggleMiddle+'px')}}};showDrawer=function(toggle){if(settings.method=='flip'){Shopify.getCart(flipCartUpdateCallback)}
else if(!cartInit&&toggle){Shopify.getCart(cartUpdateCallback)}
else if(cartInit&&toggle){sizeDrawer()}
$drawerContainer.addClass('is-visible');scrollTop();toggleCallback({'is_visible':!0})};hideDrawer=function(){$drawerContainer.removeAttr('style').removeClass('is-visible');scrollTop();toggleCallback({'is_visible':!1})};sizeDrawer=function($empty){if($empty){$drawerContainer.css('height','0px')}else{$drawerHeight=$cartContainer.outerHeight();$('.cart__row img').css('width','auto');$drawerContainer.css('height',$drawerHeight+'px')}};loadCartImages=function(){var cartImages=$('img',$cartContainer),count=cartImages.length,index=0;cartImages.on('load',function(){index++;if(index==count){switch(settings.method){case 'modal':sizeModal();break;case 'flip':case 'drawer':sizeDrawer();break}}})};formOverride=function(){$formContainer.submit(function(e){e.preventDefault();$addToCart.removeClass('is-added').addClass('is-adding');$('.qty-error').remove();Shopify.addItemFromForm(e.target,itemAddedCallback,itemErrorCallback);switch(settings.method){case 'flip':$flipContainer.addClass('flip--is-loading');break}})};itemAddedCallback=function(product){$addToCart.removeClass('is-adding').addClass('is-added');switch(settings.method){case 'flip':setTimeout(function(){$flipContainer.removeClass('flip--is-loading').addClass('is-flipped')},600);break}
Shopify.getCart(cartUpdateCallback)};itemErrorCallback=function(XMLHttpRequest,textStatus){var data=eval('('+XMLHttpRequest.responseText+')');switch(settings.method){case 'flip':$flipContainer.removeClass('flip--is-loading');break}
if(!!data.message){if(data.status==422){$formContainer.after('<div class="errors qty-error">'+data.description+'</div>')}}};cartUpdateCallback=function(cart){updateCountPrice(cart);switch(settings.method){case 'flip':$('.flip__cart span').html(cart.item_count);break;case 'modal':buildCart(cart);break;case 'drawer':buildCart(cart);if(!$drawerContainer.hasClass('is-visible')){showDrawer()}else{scrollTop()}
break}};setToggleButtons=function(){$toggleCartButton=$(settings.toggleCartButton);if($toggleCartButton){$toggleCartButton.off('click');$toggleCartButton.on('click',function(e){e.preventDefault();switch(settings.method){case 'modal':if($modalContainer.hasClass('is-visible')){hideModal()}else{showModal(!0)}
break;case 'drawer':case 'flip':if($drawerContainer.hasClass('is-visible')){hideDrawer()}else{showDrawer(!0)}
break}})}};flipCartUpdateCallback=function(cart){buildCart(cart)};buildCart=function(cart){if(!settings.useCartTemplate||cart.item_count===0){$cartContainer.empty()}
if(cart.item_count===0){$cartContainer.append('<h2>'+"Your cart is currently empty"+'</h2>').append('<p class="text-center">'+"\u003ca href=\"\/collections\/all\"\u003eContinue shopping here\u003c\/a\u003e."+'</p>');switch(settings.method){case 'modal':sizeModal('resize');break;case 'flip':case 'drawer':sizeDrawer();if(!$drawerContainer.hasClass('is-visible')&&cartInit){sizeDrawer(!0)}
break}
return}
if(settings.useCartTemplate){cartTemplate(cart);return}
var items=[],item={},data={},source=$("#CartTemplate").html(),template=Handlebars.compile(source);$.each(cart.items,function(index,cartItem){var itemAdd=cartItem.quantity+1,itemMinus=cartItem.quantity-1,itemQty=cartItem.quantity;if(cartItem.image!=null){var prodImg=cartItem.image.replace(/(\.[^.]*)$/,"_small$1").replace('http:','')}else{var prodImg="http://cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"}
var prodName=cartItem.title.replace(/(\-[^-]*)$/,""),prodVariation=cartItem.title.replace(/^[^\-]*/,"").replace(/-/,"");item={id:cartItem.variant_id,url:cartItem.url,img:prodImg,name:prodName,variation:prodVariation,itemAdd:itemAdd,itemMinus:itemMinus,itemQty:itemQty,price:Shopify.formatMoney(cartItem.price,settings.moneyFormat)};items.push(item)});data={items:items,totalPrice:Shopify.formatMoney(cart.total_price,settings.moneyFormat),btnClass:$btnClass}
$cartContainer.append(template(data));adjustCart();switch(settings.method){case 'modal':loadCartImages();break;case 'flip':case 'drawer':if(cart.item_count>0){loadCartImages()}else{sizeDrawer(!0)}
break;default:break}
cartInit=!0};cartTemplate=function(cart){var url='/cart?'+Date.now()+' form[action="/cart"]';$cartContainer.load(url,function(){adjustCart();switch(settings.method){case 'modal':loadCartImages();break;case 'flip':case 'drawer':if(cart.item_count>0){loadCartImages()}else{sizeDrawer(!0)}
$cartContainer.prepend('<button type="button" class="ajaxcart__close" title="'+"Close Cart"+'">'+"Close Cart"+'</button>');$closeCart=$('.ajaxcart__close');$closeCart.on('click',hideDrawer);break;default:break}
cartInit=!0})}
adjustCart=function(){if(settings.useCartTemplate){createQtySelectors()}
var qtyAdjust=$('.ajaxcart__qty-adjust');qtyAdjust.off('click');qtyAdjust.on('click',function(){var el=$(this),id=el.data('id'),qtySelector=el.siblings('.ajaxcart__qty-num'),qty=parseInt(qtySelector.val().replace(/\D/g,''));var qty=validateQty(qty);if(el.hasClass('ajaxcart__qty--plus')){qty=qty+1}else{qty=qty-1;if(qty<=0)qty=0}
if(id){updateQuantity(id,qty)}else{qtySelector.val(qty)}});var qtyInput=$('.ajaxcart__qty-num');qtyInput.off('change');qtyInput.on('change',function(){var el=$(this),id=el.data('id'),qty=parseInt(el.val().replace(/\D/g,''));var qty=validateQty(qty);if(id){updateQuantity(id,qty)}});qtyInput.off('focus');qtyInput.on('focus',function(){var el=$(this);setTimeout(function(){el.select()},50)});$('.ajaxcart__remove').on('click',function(e){var el=$(this),id=el.data('id')||null,qty=0;if(!id){return}
e.preventDefault();updateQuantity(id,qty)});function updateQuantity(id,qty){if(!settings.useCartTemplate){var row=$('.ajaxcart__row[data-id="'+id+'"]').addClass('is-loading')}else{var row=$('.cart__row[data-id="'+id+'"]').addClass('is-loading')}
if(qty===0){row.addClass('is-removed')}
setTimeout(function(){Shopify.changeItem(id,qty,adjustCartCallback)},250)}
var noteArea=$('textarea[name="note"]');noteArea.off('change');noteArea.on('change',function(){var newNote=$(this).val();Shopify.updateCartNote(newNote,function(cart){})})};adjustCartCallback=function(cart){updateCountPrice(cart);if(cart.item_count===0){switch(settings.method){case 'modal':break;case 'flip':case 'drawer':hideDrawer();break}}
setTimeout(function(){Shopify.getCart(buildCart)},150)};createQtySelectors=function(){if($('input[type="number"]',$cartContainer).length){$('input[type="number"]',$cartContainer).each(function(){var el=$(this),currentQty=el.val();var itemAdd=currentQty+1,itemMinus=currentQty-1,itemQty=currentQty;var source=$("#AjaxifyQty").html(),template=Handlebars.compile(source),data={id:el.data('id'),itemQty:itemQty,itemAdd:itemAdd,itemMinus:itemMinus};el.after(template(data)).remove()})}
if($('a[href^="/cart/change"]',$cartContainer).length){$('a[href^="/cart/change"]',$cartContainer).each(function(){var el=$(this).addClass('ajaxcart__remove')})}};qtySelectors=function(){var numInputs=$('input[type="number"]');if(numInputs.length){numInputs.each(function(){var el=$(this),currentQty=el.val(),inputName=el.attr('name'),inputId=el.attr('id');var itemAdd=currentQty+1,itemMinus=currentQty-1,itemQty=currentQty;var source=$("#JsQty").html(),template=Handlebars.compile(source),data={id:el.data('id'),itemQty:itemQty,itemAdd:itemAdd,itemMinus:itemMinus,inputName:inputName,inputId:inputId};el.after(template(data)).remove()});$('.js-qty__adjust').on('click',function(){var el=$(this),id=el.data('id'),qtySelector=el.siblings('.js-qty__num'),qty=parseInt(qtySelector.val().replace(/\D/g,''));var qty=validateQty(qty);if(el.hasClass('js-qty__adjust--plus')){qty=qty+1}else{qty=qty-1;if(qty<=1)qty=1}
qtySelector.val(qty)})}};validateQty=function(qty){if((parseFloat(qty)==parseInt(qty))&&!isNaN(qty)){}else{qty=1}
return qty};scrollTop=function(){if($body.scrollTop()>0||$html.scrollTop()>0){$('html, body').animate({scrollTop:0},250,'swing')}};toggleCallback=function(data){data.method=settings.method;if(typeof settings.onToggleCallback=='function'){settings.onToggleCallback.call(this,data)}};module={init:init};return module}(ajaxifyShopify||{},jQuery))
$('.ajax_addtocart.disabled').click(function(){
	event.preventDefault();
})
